export default __webpack_public_path__ + "static/media/modelimg.f9739dbb.png";